import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import {Home} from './pages/Home'
import {Header} from "./components/Header";
import {Error} from "./components/Error";
import reportWebVitals from './reportWebVitals';
import {Results} from "./pages/Results";
import {Freelances} from './pages/Freelances';
import {SurveyProvider, ThemeProvider} from "./utils/context";
import {Footer} from "./components/Footer";
import {Survey} from "./pages/Survey";
import {GlobalStyle} from "./utils/styles/GlobalStyle";


ReactDOM.render(
    <React.StrictMode>
        <Router>
            <ThemeProvider>
                <SurveyProvider>
                    <GlobalStyle/>
                    <Header/>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/survey/:questionNumber" element={<Survey/>}/>
                        <Route path="/results" element={<Results/>}/>
                        <Route path="/freelances" element={<Freelances/>}/>
                        <Route path="*" element={<Error/>}/>
                    </Routes>
                    <Footer/>
                </SurveyProvider>
            </ThemeProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
